var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "grid-view" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.view === "list",
                expression: "view==='list'"
              }
            ],
            staticClass: "main-content"
          },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": _vm.configModule,
                  "expand-adv": true,
                  "show-simple": false,
                  "custom-search-items": _vm.customSearchItems
                },
                on: { advSearchItemCallBack: _vm.queryHandler },
                scopedSlots: _vm._u([
                  {
                    key: "searchAreaHeader",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "app-main-inner-row",
                            staticStyle: { display: "flex" },
                            attrs: { slot: "operations" },
                            slot: "operations"
                          },
                          [
                            _c(
                              "el-form",
                              {
                                attrs: { inline: "", "label-position": "left" }
                              },
                              [
                                _c("cargo-area", {
                                  staticStyle: { display: "inline-block" },
                                  attrs: {
                                    country: "CN",
                                    province: _vm.filter.province,
                                    city: _vm.filter.city,
                                    district: _vm.filter.district,
                                    town: _vm.filter.town,
                                    "province-label-width": "45",
                                    "city-label-width": "45",
                                    "district-label-width": "45",
                                    "show-town": true,
                                    "select-width": 290,
                                    "label-width": "85"
                                  },
                                  on: {
                                    "update:province": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "province",
                                        $event
                                      )
                                    },
                                    "update:city": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "city",
                                        $event
                                      )
                                    },
                                    "update:district": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "district",
                                        $event
                                      )
                                    },
                                    "update:town": function($event) {
                                      return _vm.$set(
                                        _vm.filter,
                                        "town",
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          disabled: !_vm.selectedRow,
                          no: "view"
                        },
                        on: { click: _vm.detail }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                    ),
                    !_vm.look
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled:
                                !_vm.selectedRow ||
                                _vm.selectedRow.status ===
                                  _vm.SystemConstants.PRICE_STATUS_NORMAL.code,
                              no: "edit"
                            },
                            on: { click: _vm.edit }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                        )
                      : _vm._e(),
                    !_vm.look
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              disabled: !_vm.selectedRow,
                              no: "copy"
                            },
                            on: { click: _vm.copy }
                          },
                          [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Copy")))]
                        )
                      : _vm._e(),
                    !_vm.look
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "add" },
                            on: { click: _vm.add }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                        )
                      : _vm._e(),
                    !_vm.look
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "shelving" },
                            on: { click: _vm.shelving }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Shelving")))]
                        )
                      : _vm._e(),
                    !_vm.look
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "unShelving" },
                            on: { click: _vm.unShelving }
                          },
                          [_vm._v(_vm._s(_vm.$t("SystemMaintenance.Remove")))]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
              [
                _c("cargo-ag-grid-wrapper", {
                  staticStyle: { height: "100%" },
                  attrs: {
                    "config-module": "2025050221",
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData,
                    "show-selected-color": false,
                    "check-sub-record": false
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "2025050221",
                    total: _vm.filter.total,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.fetchDataByPage
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm.view === "detail"
          ? _c("price-pre-port-detail", {
              ref: "pricePrePortLastMileDetail",
              attrs: { look: _vm.look },
              on: {
                back: _vm.back,
                cancel: function($event) {
                  _vm.view = "list"
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }